import { useDispatch, useSelector } from "react-redux";
import { Text, Stack,  Spinner } from "../index";
import { qrLoginActions, qrLoginSelectors } from "../../redux/qrLogin";
import useInterval from "use-interval";
import { useEffect } from "react";
import { ICONS } from "../../icons";

export function QrLoginQRStep() {
    const dispatch = useDispatch();

    const operation = useSelector(qrLoginSelectors.getOperation);
    
    useEffect(() => {
        if(!operation){
			dispatch(qrLoginActions.fetchLoginToken());
        }
	}, [dispatch]);

    const status = useSelector(qrLoginSelectors.getStatus);
    const svg = useSelector(qrLoginSelectors.getLoginRequestTokenSVG);

    const qr = document.getElementById("qr");
	if (qr) qr.innerHTML = svg;
	if (qr) qr.style.transform = "scale(0.8)";

    useInterval(() => {
        if(operation?.uid){
		    dispatch(qrLoginActions.pollLoginOperation(operation.uid))
        }

	}, status === "PENDING" ? 2000 : null);

    return (
        <div>
            <Stack vertical center spacing={0}>
                {status === "ERROR" 
                && <div style={{marginTop: "3rem"}}>
                        <Text.Paragraph.p color="danger300">
                            {"Error"}
                        </Text.Paragraph.p>
                </div>}
                <div id="qr"></div>
                {status === "PENDING" && <div style={{marginTop: "3rem"}}><Spinner/></div>}
                {status === "SUCCESS"
                && <img src={ICONS.Success} alt="Success"/>}
            </Stack>  
        </div>
    )
}